import { Parameters } from 'constants/queryParameters';
import { useQuerySearchParams } from './useQuerySearchParams';

/**
 *
 * @example
 *   const [orderByName, setOrderByName] = useQueryOrder();
 */
export const useQueryOrder = () =>
  useQuerySearchParams<[string, string]>(Parameters.order);
